import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";

import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess } from 'components/user-access';
import { HorizontalLinkGroup } from 'components/navigation';
import { JourneyTypes } from 'pages/account/edit/alert-settings/journey-types/JourneyTypes';
import { AlertHistory } from 'pages/account/edit/alert-settings/history/AlertHistory';

export function AlertSettings(props) {
    const requiredAction = "TachoAlerts:Manage";

    const routes = [
        { location: "/account/alert-settings/journey-types", title: "Journey Types" },
        { location: `${window.env.VISIONMEMBER_URL}/#/alertsadmin?tab=dismissal-settings`, title: "Auto Dismiss", externalLink: true },
        { location: `${window.env.VISIONMEMBER_URL}/#/alertsadmin?tab=vehicle-odometer`, title: "Alert Specific Settings", externalLink: true },
        { location: "/account/alert-settings/history", title: "History" }
    ];

    return (
        <UserAccess perform={requiredAction}
            yes={() => (
                <div className="row">

                    <h2>Alert Settings</h2>
                    <div className="intro-text">
                        <p>Here you can manage all settings for your alerts.</p>
                    </div>

                    <div className="spacer-bottom">
                        <HorizontalLinkGroup links={routes} exactRouteMatch={false}></HorizontalLinkGroup>

                    </div>

                    <Routes>
                        <Route path="journey-types" element={<JourneyTypes />} />
                        <Route path="history" element={<AlertHistory />} />
                        <Route path="" element={<Navigate to="/account/alert-settings/journey-types" replace />} />
                    </Routes>


                </div>
            )}
            no={() => (
                <div className="row">
                    <PageRestricted />
                </div>
            )}
        />
    );
}